/*!
 * jQuery version of header mobile/desktop drawer toggles
 * - Mirrors the behavior of the original vanilla JS but using jQuery.
 * - Sets aria-hidden on wrappers by breakpoint, debounced resize handler.
 * - Wires mobile toggles (.nav-toggle, summary.header__icon--summary, .header__icon--menu)
 *   to open/close the first details element or toggle a .is-open class on .nav-menus-wrapper.
 */

if (typeof jQuery === 'undefined') {
  console.warn('header-mobile-menu.jquery.js: jQuery not found. This script requires jQuery.');
} else {
  (function ($) {
    $(function () {

      // Wire mobile nav toggles (open/close)
      if ($(".header-drawer-wrapper.mobile-only").length) {

        // Open / close main mobile menu
        $(".header__icon--menu").on("click", function() {
            const $drawer = $(".header-drawer-wrapper.mobile-only .nav-menus-wrapper");
            const $container = $("details#Details-menu-drawer-container");

            $drawer.toggleClass("nav-menus-wrapper-open");
            const isOpen = $drawer.hasClass("nav-menus-wrapper-open");

            $(this).attr("aria-expanded", String(isOpen));
            $container.toggleClass("menu-opening", isOpen);
        });

        // Close button action
        $(".header-drawer-wrapper.mobile-only .nav-menus-wrapper-close-button").on("click", function() {
            const $drawer = $(".header-drawer-wrapper.mobile-only .nav-menus-wrapper");
            const $container = $("details#Details-menu-drawer-container");

            $drawer.removeClass("nav-menus-wrapper-open");
            $container.removeClass("menu-opening");
            $(".header__icon--menu").attr("aria-expanded", "false");
        });

        // Submenu toggle in mobile nav
        $(".nav-menu--mobile a[href='#']").on("click", function(e) {
            e.preventDefault();

            const $submenu = $(this).next(".nav-dropdown");
            const $siblings = $(this).closest("li").siblings().find(".nav-dropdown");

            $siblings.slideUp();
            $submenu.stop(true, true).slideToggle();
        });
        }


        const items = $(".nav-menu--mobile li").length;

        for (let i = 1; i <= items; i++) {
        const delay1 = (0.12 + (i - 1) * 0.03).toFixed(2);
        const delay2 = (0.20 + (i - 1) * 0.03).toFixed(2);
        const css = `
            .appear-delay-${i} {
            transition: transform 1s cubic-bezier(.165,.84,.44,1) ${delay1}s,
                        opacity 1s cubic-bezier(.165,.84,.44,1) ${delay2}s;
            }`;
        $("<style>").text(css).appendTo("head");
        }






    });
  })(jQuery);
}